import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { authorizedFetch } from '../utils/api';

// Spinner copied from KnowledgeBase
function Spinner() {
  return (
    <div className="flex justify-center items-center h-32">
      <svg className="animate-spin h-8 w-8 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
    </div>
  );
}

export default function History() {
  const [looks, setLooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [renderTime, setRenderTime] = useState(null);
  const [showRenderTime, setShowRenderTime] = useState(false);
  const renderStartRef = React.useRef(null);

  useEffect(() => {
    renderStartRef.current = performance.now();
    async function fetchHistory() {
      setLoading(true);
      setError(null);
      const { data } = await supabase.auth.getSession();
      const token = data?.session?.access_token;
      await authorizedFetch('/api/history')
        .then(res => {
          if (!res.ok) throw new Error('Failed to fetch history');
          return res.json();
        })
        .then(data => {
          setLooks(Array.isArray(data) ? data : []);
          setLoading(false);
          // Calculate render time
          const end = performance.now();
          const seconds = ((end - renderStartRef.current) / 1000).toFixed(2);
          setRenderTime(seconds);
          setShowRenderTime(true);
          setTimeout(() => setShowRenderTime(false), 5000);
        })
        .catch(err => {
          setError(err.message);
          setLoading(false);
        });
    }
    fetchHistory();
  }, []);

  if (loading) return <Spinner />;
  if (error) return <div className="text-center text-red-500">Error: {error}</div>;
  if (!Array.isArray(looks) || looks.length === 0) return <div className="text-center text-gray-400">No uploads found.</div>;

  return (
    <div className="max-w-5xl mx-auto p-6 animate-fade-in" style={{ position: 'relative' }}>
      <h1 className="text-2xl font-bold mb-6">History</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {looks.map(look => (
          <div key={look.image_url + look.uploaded_at} className="bg-white rounded-lg shadow p-4 flex flex-col">
            <div className="mb-2">
              <img src={look.image_url} alt="look" className="w-full max-h-48 object-contain rounded" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-gray-500 mb-1">Machine Score: <span className="font-bold">{look.machine_score ?? '-'}</span></div>
              <div className="text-xs text-gray-500 mb-1">Buyer Score: <span className="font-bold">{look.buyer_score ?? '-'}</span></div>
              <div className="text-xs text-gray-400 mb-1">{look.uploaded_at ? new Date(look.uploaded_at).toLocaleString() : ''}</div>
            </div>
          </div>
        ))}
      </div>
      {showRenderTime && (
        <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 50 }} className="bg-gray-800 text-white text-xs px-3 py-1 rounded shadow animate-fade-in">
          Render Time: {renderTime} seconds
        </div>
      )}
    </div>
  );
} 